import { useState, useEffect } from 'react';

let _show = null;

export function showConfirm({ title, description, confirmLabel = 'Ta bort', cancelLabel = 'Avbryt', onConfirm, onCancel }) {
  if (_show) _show({ title, description, confirmLabel, cancelLabel, onConfirm, onCancel });
}

export function ConfirmDialogContainer() {
  const [dialog, setDialog] = useState(null);

  useEffect(() => {
    _show = (opts) => setDialog(opts);
    return () => { _show = null; };
  }, []);

  if (!dialog) return null;

  const confirm = () => { setDialog(null); dialog.onConfirm?.(); };
  const cancel = () => { setDialog(null); dialog.onCancel?.(); };

  return (
    <div
      onClick={cancel}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 10000, display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        padding: '16px',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'white', borderRadius: '14px',
          padding: '28px 28px 24px',
          maxWidth: '380px', width: '100%',
          boxShadow: '0 24px 80px rgba(0,0,0,0.25)',
        }}
      >
        <h3 style={{ margin: '0 0 8px', fontSize: '1em', fontWeight: '700', color: '#0f172a' }}>
          {dialog.title}
        </h3>
        {dialog.description && (
          <p style={{ margin: '0 0 24px', color: '#64748b', fontSize: '0.875em', lineHeight: '1.5' }}>
            {dialog.description}
          </p>
        )}
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button
            onClick={cancel}
            style={{
              padding: '9px 18px', background: 'white',
              border: '1px solid #d1d5db', borderRadius: '8px',
              cursor: 'pointer', fontSize: '0.875em',
              color: '#374151', fontWeight: '500',
            }}
          >
            {dialog.cancelLabel}
          </button>
          <button
            onClick={confirm}
            style={{
              padding: '9px 18px', background: '#dc2626',
              border: 'none', borderRadius: '8px',
              cursor: 'pointer', fontSize: '0.875em',
              color: 'white', fontWeight: '600',
            }}
          >
            {dialog.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
